module.exports = __webpack_public_path__ + "static/img/fhabian-frontpage--1.bdcef75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jpgs/fhabian-frontpage--1.jpg
// module id = aM3Y
// module chunks = 1